import { initialAbility } from './initialAbility'
import accessLevelWiseAbilityJson from './accessLevelWiseAbility.json';

export const accessLevelWiseAbility  = (userInfo) => {

  const availableAccessLevels = [1, 2, 3, 4];

  if ( !userInfo
    || !userInfo.accessLevel
    || availableAccessLevels.indexOf(userInfo.accessLevel) == -1
    ) {
    return initialAbility;
  }

  return (userInfo['ability'] && userInfo['ability']['actions'] || initialAbility)

}